<template>
    <div>
        <div class="content">
            <van-tree-select height="" class="treeSelect" :items="CategoryList" :main-active-index.sync="ActiveName" @click-nav="clickActive">
                <template #content>
                    <div>
                        <div v-if="activeName==0" >
                            <div class="lintTitle">
                                <line-title  title="热销产品"></line-title>
                            </div>
                            <div class="hotImgBox">
                                <div v-for="(items,index) of hotList" :key="index"  class="hotImg" @click="detail(items)">
                                    <img class="img" :src="items.photo_s" alt="">
                                </div>
                            </div>
                            <div style="width:100%;height:10px;background:#f5f5f5"></div>
                        </div>
                        <div class="listContent">
                                <div v-for="(items,i) of categoryList" :key="i"  >
                                <product-list-item v-if="activeName === i" :category="items"></product-list-item>
                            </div>
                        </div>
                    </div>
                </template>
                 
            </van-tree-select>
        </div>
        <tabbar :active="active"></tabbar>
    </div>
</template>

<script>
import tabbar from "@/components/tabbar"
import productListItem from "@/components/productListItem"
import lineTitle from "@/components/lineTitle"
import { PullRefresh } from 'vant'
import {mapState} from "vuex"
import { Dialog,Toast } from 'vant';
export default {
    data() {
        return {
            active:"product",//底部导航栏默认选中
            // activeName:0,    //默认展示第一个分类
            // tabList:[{tabId:0,text:"全部"},{tabId:1,text:"医疗险"},{tabId:2,text:"重疾险"},{tabId:3,text:"意外险"},{tabId:4,text:"寿险"},{tabId:5,text:"财产险"}],
            // categoryList:[],
            hotList:[],
            isLoading:false,
        };
    },
    created(){
        document.title="保险商城";
        if(!this.categoryList){
            this.getCategoryList();
        }
        this.getHotList();
    },
    mounted(){
        // this.addEvent()
    },
    methods: {
        onload(){
            console.log("有这个事件吗")
        },
        // onRefresh() {
        //         this.isLoading = false;

        //         this.activeName-=1;
        // },
        // change(e){
        //     // console.log(e)
        // },
        detail(info){
            this.$router.push("/productDetails?id="+info.id)
            // pjh
            // if(info.is_report==0){   //未报备
            //     this.$router.push("/productDetails?id="+info.id)
            // }else if(info.is_report==1){  //已报备
            //     // window.location.href=info.out_insure_url;
            //     window.open(info.out_insure_url);
            // }
        },
        clickActive(e){
            // console.log(this.activeName,"*****",e)
            this.$store.commit('SET_ACTIVENAME',e)
            
        },
        getCategoryList(){
            this.$https.fetchPost("Goods/category",{},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                if(result.data.code==1 ){
                    // this.categoryList=data.data
                    let data=result.data.data;
                    data.forEach(element => {
                        for(var key in element){
                            if(key=="val"){
                                element["text"]=element[key];
                            }
                        }
                    });
                    // this.categoryList=[...[{key:"",text:"全部"}],...data,...[{key:"is_down",text:"下架产品"},{key:"is_report",text:"备案中"}]];
                    let categoryList=[...[{key:"",text:"全部"}],...data,...[{key:"is_down",text:"下架产品",is_down:'1'},{key:"is_report",text:"备案中",is_report:'0'}]];
                    this.$store.commit('SET_CATEGORYLIST',categoryList)
                }
            })
        },
        getHotList(){
            this.$https.fetchPost("Goods/index",{"is_hot":"1","is_report":"1"},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                if(result.data.code==1){
                    let list=result.data.data;
                    if(list.length>3){
                        this.hotList=list.splice(0,3);
                    }else{
                        this.hotList=list;
                    }
                }else if(result.data.code==10001){  //有token,用户未登陆情况
                    this.$store.commit("LOGOUT")
                    this.$router.push("/login")
                }else{
                    Toast(result.data.msg)
                }
            })
        },
    },
    components:{
        tabbar,
        productListItem,
        lineTitle
    },
    computed:{
        ...mapState(["token","categoryList","activeName"]),
        CategoryList(){
            return !this.categoryList ? [] : this.categoryList
        },
        ActiveName:{
            get(){
                return this.activeName;
            },
            set(newValue){
                return newValue
            }
        },
        disabled(){
            return this.activeName!=0 ? false :true;
        }
    },
}
</script>

<style scoped>
 .content{
    /* padding: 12px; */
    text-align: start;
  }
  .content /deep/ .van-tab{
      flex-basis:16.6% !important;
      /* justify-content:space-between !important; */
  }
   .content /deep/ .van-tabs__line{
    bottom: 0.5rem;
  }
  .content /deep/ .van-cell{
      padding:0;
      background: transparent;
  }
  .treeSelect{
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom:50px;
  }

    .lintTitle{
        margin: 10px 0;
    }
    .lintTitle /deep/ .title{
        padding-top:1PX;
    }

  .van-tree-select__nav{
      flex: 0.8195;
  }
  .van-tree-select__nav-item{
    text-align: center;
    height: 44px;
    line-height: 44px;
    font-size:14px;
    padding:0 14px 0 21px;
    font-weight: 500;
    color: #333;
    align-items: center;
  }
  .van-sidebar-item--select{
      background: linear-gradient(-270deg,rgba(243,71,64,1),rgba(254,142,137,1));
      color: #fff;
  }
  .van-sidebar-item--select::before{
        background: transparent;
        width: 8px;
        height: 11px;
        margin-left: 14px;
        background-image: url("../../assets/icons/sanjiao.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
  }
  .hotImgBox{
      display: flex;
      justify-content: space-between;
      margin:14px 15px  0 15px;

  }
  .hotImg{
      width: 75px;
      height: 75px;
      border-radius: 10px;
      overflow: hidden;
      text-align: center;
      margin-bottom: 12px;
  }
  .img{
      height: 100%;
  }
  .listContent{
      padding-top: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/views/product/productList.vue